import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=58fbd236&scoped=true&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"
import style0 from "./invoice.vue?vue&type=style&index=0&id=58fbd236&scoped=true&lang=css&"
import style1 from "./invoice.vue?vue&type=style&index=1&id=58fbd236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbd236",
  null
  
)

export default component.exports